import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_SAAS_DEV, COVERGO_SAAS_PROD } from "../consts.js"

export const coverHealthDev = {
	"cover-health-dev-studio.quote.hk": {
		appConfig: appConfigCoverGoDev,
		envConfig: COVERGO_SAAS_DEV,
		// CH-52544: HttpOnly-cookie session auth + IdentityServer-hosted login for this host.
		// Both flags MUST stay on the host entry: appConfigCoverGoDev is shared with the demo
		// host below and COVERGO_SAAS_DEV with ~30 others, so either would leak the flag.
		cookieModeEnabled: true,
		loginMode: "CodeFlow",
	},
	"cover-health-demo-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_SAAS_PROD }
}
